import { render, staticRenderFns } from "./DistrictNameInput.vue?vue&type=template&id=02a04542&"
import script from "./DistrictNameInput.vue?vue&type=script&lang=ts&"
export * from "./DistrictNameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports